import { ReactNode, useEffect } from 'react';

import { useGetBrandingQuery } from '../../lendingApi/lendingApiQueries';

type TProps = {
  children: ReactNode;
};

const Branding = ({ children }: TProps) => {
  const { branding } = useGetBrandingQuery();

  useEffect(() => {
    if (branding && branding.signup_branding_type === 'partner') {
      const {
        primary_colour,
        secondary_colour,
        title_colour,
        primary_theme,
        secondary_theme,
      } = branding.data;

      if (primary_colour) {
        document.documentElement.style.setProperty(
          '--color-primary',
          primary_colour,
        );
        document.documentElement.style.setProperty(
          '--color-title',
          title_colour || primary_colour,
        );
      }

      if (secondary_colour) {
        document.documentElement.style.setProperty(
          '--color-secondary',
          secondary_colour,
        );
      }

      document.documentElement.style.setProperty(
        '--theme-primary',
        primary_theme === 'light' ? '#333' : '#FFF',
      );

      document.documentElement.style.setProperty(
        '--theme-secondary',
        secondary_theme === 'light' ? '#333' : '#FFF',
      );
    }
  }, [branding]);

  return <>{children}</>;
};

export default Branding;
